import { render, staticRenderFns } from "./projectAdvantageWidge.vue?vue&type=template&id=29659a94&scoped=true"
import script from "./projectAdvantageWidge.vue?vue&type=script&lang=js"
export * from "./projectAdvantageWidge.vue?vue&type=script&lang=js"
import style0 from "./projectAdvantageWidge.vue?vue&type=style&index=0&id=29659a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29659a94",
  null
  
)

export default component.exports